var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThermometer = function SvgThermometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.667 3.75a4.583 4.583 0 0 0-4.584 4.583v13.485a7.917 7.917 0 1 0 9.167 0V8.334a4.583 4.583 0 0 0-4.583-4.583m-2.084 12.5v6.25c0 .447-.238.86-.625 1.082a5.417 5.417 0 1 0 5.417 0 1.25 1.25 0 0 1-.625-1.082v-6.25zm4.167-2.5V8.333a2.083 2.083 0 0 0-4.167 0v5.417z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.417 15c0-.69.56-1.25 1.25-1.25h3.75V10a1.25 1.25 0 1 1 2.5 0v3.75h3.75a1.25 1.25 0 0 1 0 2.5h-3.75V20a1.25 1.25 0 0 1-2.5 0v-3.75h-3.75c-.69 0-1.25-.56-1.25-1.25"
  })));
};
export default SvgThermometer;